export enum FireStoreCollection {
	USERS = 'users',
	ORGANISATIONS = 'organisations',
	ORGANISATION_USER = 'organisation-user',
	CLIENTS = 'clients',
	INVENTORY_ITEMS = 'inventory-items',
	INVENTORY_LOCATIONS = 'inventory-locations',
	INVENTORY_ITEMS_LOCATIONS = 'inventory-item-locations',
	INVENTORY_CATEGORIES = 'inventory-categories',
	INVENTORY_STOCK_ADJUSTMENT = 'inventory-stock-adjustment',
	LEAD_REQUESTS = 'lead-requests',
	LEAD_ASSESSMENTS = 'lead-assessments',
	MAIL = 'mail',
	MAIL_TEMPLATES = 'mail-templates',
}

export interface FireStoreDocument {
	id?: string;
}
